import { render, staticRenderFns } from "./v-option.vue?vue&type=template&id=1bbba944&scoped=true&"
import script from "./v-option.vue?vue&type=script&lang=js&"
export * from "./v-option.vue?vue&type=script&lang=js&"
import style0 from "./v-option.vue?vue&type=style&index=0&id=1bbba944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbba944",
  null
  
)

export default component.exports